/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IHeaderViewProps } from '@msdyn365-commerce-modules/header/dist/types/modules/header/header';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IHeaderProps } from '../definition-extensions/header.ext.props.autogenerated';

// tslint:disable-next-line: max-func-body-length
const headerView: React.FC<IHeaderViewProps & IHeaderProps<{}>> = props => {
    const { config, HeaderTag, HeaderContainer, HeaderTopBarContainer, MobileMenuContainer, MobileMenuBodyContainer } = props;
    const showCartIcon = config.cartIcon;
    const showAccountBlock = config.accountBlock;

    return (
        <Module {...HeaderTag} role="none">
            <Node {...HeaderContainer}>
                <Node {...HeaderTopBarContainer}>
                    {props.logo}
                    <div className='ms-header-content'>
                        {config.storeHours && <div className='ms-store-hours'>{config.storeHours}</div>}
                        {_renderReactFragment(props.search)}
                        {props.slots && props.slots.smweSearch && _renderReactFragment(props.slots.smweSearch)}
                    </div>
                    {showAccountBlock && _renderDesktopAccountBlock(props)}
                    {showCartIcon && props.cartIcon}
                </Node>
                <Node className='mobile-vp'>
                    {props.logo}
                </Node>
                <Node {...MobileMenuContainer}>
                    <Node {...MobileMenuBodyContainer}>
                        { props.MobileMenuHeader }
                        {props.menuBar && _renderReactFragment(props.menuBar)}
                        {props.slots && props.slots.smweMenuBar && _renderReactFragment(props.slots.smweMenuBar)}
                    </Node>
                </Node>
                {props.menuBar && _renderReactFragment(props.menuBar)}
                {props.slots && props.slots.smweMenuBar && _renderReactFragment(props.slots.smweMenuBar)}
            </Node>
        </Module>
    );
};

function _renderDesktopAccountBlock(props: IHeaderViewProps): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
        accountInfoDropdownButton,
        signOutLink,
        signInLink,
        accountLinks
    } = props;

    if (AccountInfoDropdownParentContainer) {
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <Node {...AccountInfoDropdownParentContainer}>
                    {accountInfoDropdownButton}
                    <Node {...AccountInfoDropdownPopoverConentContainer}>
                        {accountLinks ? accountLinks.map(link => link) : false}
                        {signOutLink}
                    </Node>
                </Node>
            );
        } else if (signInLink) {
            return <Node {...AccountInfoDropdownParentContainer}>{signInLink}</Node>;
        }
    }

    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <React.Fragment>
            {items && items.length
                ? items.map((slot: React.ReactNode, index: number) => {
                    return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </React.Fragment>
    );
}

export default headerView;
